export const CHAT_ENDPOINT='wss://chat.thecloserai.com'
//export const CHAT_ENDPOINT='ws://192.168.50.94:8000'
